import './SystemHealth.css';       // ← makes sure our CSS is loaded
import HealthCard from '../components/HealthCard';

/* ---------- env helpers ---------- */
const PROJECT_NUMBER = process.env.REACT_APP_PROJECT_NUMBER;
const REGION         = process.env.REACT_APP_REGION;

const buildServiceUrl = (slug, buildType) =>
  `https://${slug}-${buildType}-${PROJECT_NUMBER}.${REGION}.run.app/`;

/* ---------- component ------------ */
function SystemHealth() {
  const buildType = (process.env.REACT_APP_BUILD_TYPE || 'staging').toLowerCase();

  /* ─────── service definitions ─────── */

  const orderProcessing = [
    { slug: 'webhook-receiver',     name: 'Webhook Receiver'  },
    { slug: 'webhook-processor',    name: 'Webhook Processor' },
    { slug: 'download-generator',   name: 'Download Generator' },
    { slug: 'activation-generator', name: 'Activation Generator' },
    { slug: 'cloud-email-processor', name: 'Cloud Emailer' },
  ];

  const userServices = [
    { slug: 'download-processor',   name: 'Download Processor' },
    { slug: 'activation-processor', name: 'Activation Processor' },
  ];

  const internalServices = [
    { slug: 'product-utils',   name: 'Product Utils' },
    { slug: 'encryption-utils',   name: 'Encryption Utils' },
    { slug: 'webhook-utils', name: 'Webhook Utils' },
  ];
  
  const mapServices = arr =>
    arr.map(s => ({ ...s, url: buildServiceUrl(s.slug, buildType) }));

  /* ─────── render ─────── */

  return (
    <>
      {/* environment banner */}
      <div className="env-banner">
        App infrastructure in use:&nbsp;{buildType.toUpperCase()}
      </div>

      <div className="health-wrapper">

        {/* Order processing column with cascade */}
        <div className="cascade col">
          <h3 className="group-title">Order&nbsp;Processing</h3>
          {mapServices(orderProcessing).map(({ name, url }) => (
            <HealthCard key={name} name={name} url={url} />
          ))}
        </div>

        {/* User services row – no connectors */}
        <div className="row">
          <h3 className="group-title">User&nbsp;Services</h3>
          <div className="row-cards">
            {mapServices(userServices).map(({ name, url }) => (
              <HealthCard key={name} name={name} url={url} />
            ))}
          </div>
          <br />
          <h3 className="group-title">Internal&nbsp;Services</h3>
          <div className="row-cards">
            {mapServices(internalServices).map(({ name, url }) => (
              <HealthCard key={name} name={name} url={url} />
            ))}
          </div>

        </div>
      </div>
    </>
  );
}

export default SystemHealth;
